import { useState } from "react";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import { useCustomHook } from "../../../globalComponents/GlobalFunctions/globalFunctions";

const CallDatesDropdown = ({ data }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { callDatesStatusList } = useCustomHook();

  console.log(data);

  return (
    <div
      className={`global-category-dropdown dropdown-name data-status  ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>Bütün zəng tarixləri</h2>
        <div className="arrow-icon" style={{ marginLeft: "10px" }}>
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {data?.callDates?.map((item) => (
            <li
              key={item._id}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <span>{item.date}</span>
              <span>
                {
                  callDatesStatusList?.find(
                    (dateStatus) => dateStatus.key === item?.status
                  )?.label
                }
              </span>
              <span>{item.isFollowUp ? "Follow up" : ""}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CallDatesDropdown;
